import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Online_Mba from "./components/online-mba/Online_Mba";
import ThankYou from "./components/thank-you/Thank_you";

function App() {
  return (
    <>
      {/* <ScrollToTop /> */}
      <Header />
      <Routes>
        <Route path="/" element={<Online_Mba />} />
        <Route path="/learningwithoutlimits" element={<Online_Mba />} />
        <Route path="/admissionprocess" element={<Online_Mba />} />
        <Route path="/eligibility" element={<Online_Mba />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
